// extracted by mini-css-extract-plugin
module.exports = {"resourceRow":"ResourcesDataCell_resourceRow__1iuVZ","resource":"ResourcesDataCell_resource__2UFir","LINK":"ResourcesDataCell_LINK__1ea19","PDF":"ResourcesDataCell_PDF__7MS43"};